import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { KeycloakService } from "keycloak-angular";
import { DataService } from '../data.service';
import { environment } from 'src/environments/environment';
import { IonModal } from '@ionic/angular';
import { OAuthService } from 'angular-oauth2-oidc';
import { catchError, finalize, firstValueFrom, of, timeout } from 'rxjs';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-bkontir',
  templateUrl: './bkontir.component.html',
  styleUrls: ['./bkontir.component.scss'],
})
export class bKontirComponent implements OnInit {

  feljegyzesek = []
  user$
  loginMode
  userMetadata
  uuid
  @ViewChild('feljegyzesmodal') feljegyzesmodal: IonModal;
  f
  sajatIntezmeny
  ugyfel
  cegParam = ''
  statusz = { NEEDS_REVIEW_POSTED: "Kontírozás szükséges!", REVIEWED: "Felülvizsgálva", KIEGYENLITES: "Kiegyenlítve!", ELOIRAS: "Még nincs rendezve!" }
  adatok
  eloiras
  partnerOptions = []
  partnerOptionsLoading = false
  partnerOptionsLoadedFor = ''
  private readonly hardcodedBankRules = [
    {
      key: 'nav_afa',
      name: 'NAV ÁFA',
      accountNumbers: ['10032000-01076868', '1003200001076868', '10032000-01076868-00000000', 'HU59100320000107686800000000'],
      partnerName: 'NAV Általános forgalmi adó bevételi számla',
      partnerCode: '104',
      tipus: 'b',
      tartozik: '467',
    },
  ];

  constructor(private route: ActivatedRoute, public oauth: OAuthService, private data: DataService, private http: HttpClient) { }

  async ngOnInit() {
    await this.oauth.loadUserProfile();
    this.user$ = this.data.belepoKilet(this.oauth.getIdentityClaims()) as any;
    this.loginMode = await this.data.getFromStorage("loginmode")
    this.sajatIntezmeny = (await this.data.getFromStorage("sajatIntezmeny"))

    this.userMetadata = (await this.data.getFromStorage("userMetadata"))
    let param = await this.route.snapshot.paramMap.get('adoszam');
    this.cegParam = String(param ?? '').trim();

    this.http
      .get(
        environment.n8n +
        '/webhook/getugyfel?ugyfel=' + param
      )
      .subscribe({
        next: async (response: any) => {
          this.ugyfel = response[0];
          await this.data.setStorage("kivceg", this.ugyfel)
          this.uuid = this.user$.username
          console.log(response)

          await this.data.showLoading("Kontír lehívása...")
          this.http
            .get(
              environment.n8n +
              '/webhook/kontir?ceg=' + this.ugyfel.ADOSZAM
            )
            .subscribe({
              next: async (response2: any) => {
                this.feljegyzesek = response2.filter(f => !f._summary);
                
                this.adatok = response2.filter(f => f._summary)[0]._summary;
                //this.feljegyzesek.shift()
                this.feljegyzesek.forEach(f => {
                  f.bankAccountNumber = f.bankAccountNumber || this.getBankCounterpartyAccount(f);
                  f.bankPartner = f.bankPartner || f.partner || '';
                  f.konyvelesiPartnerNev = f.konyvelesiPartnerNev || f.partnerNev || f.partner_nev || '';
                  f.partnerNev = f.konyvelesiPartnerNev;
                  f.partnerAzonosito = f.partnerAzonosito || f.partner_azonosito || f.partnerCode || f.partner_kod || '';
                  f.partnerCode = f.partnerCode || f.partnerAzonosito || '';
                  f.tipus = "x"
                  f.szabaly = "a"
                  f.szabalyfeltetel=[0,0,0,0]
                  f.mutat = [f.docNo, f.partnerAzonosito, f.partnerNev || f.partner, f.amount].filter(Boolean).join(" ")
                  if (f.text.toLowerCase().includes("díj")) {
                    /*f.tipus="a"
                    f.tartozik="532"
                    f.kovetel="3841"*/
                  } else if (!f.tartozik)
                    f.tartozik = this.adatok.fokszam
                  else if (!f.kovetel)
                    f.kovetel = this.adatok.fokszam

                  f.tipus = this.detectTipusFromAccounts(f);
                  this.applyHardcodedBankRule(f);
                  this.refreshEloirasOptions(f);

                  f._edited = false
                  f._original = {
                    docType: f.docType,
                    tipus: f.tipus,
                    szabaly: f.szabaly,
                    szabalyfeltetel: [...f.szabalyfeltetel],
                    tartozik: f.tartozik,
                    kovetel: f.kovetel,
                    kontir: f.kontir ? [...f.kontir] : [],
                    reszosszeg: f.reszosszeg || 0,
                    partner: f.partner || '',
                    bankPartner: f.bankPartner || '',
                    bankAccountNumber: f.bankAccountNumber || '',
                    konyvelesiPartnerNev: f.konyvelesiPartnerNev || '',
                    partnerNev: f.partnerNev || '',
                    partnerAzonosito: f.partnerAzonosito || '',
                    partnerCode: f.partnerCode || '',
                  }
                })
                console.log(response2)
                this.loadPartnerOptions(true)

                await this.data.hideLoading()
              },
              error: async () => {
                await this.data.hideLoading()
              },
            });

        },
      });
    //this.userMetadata.department = "rendszergazda"


  }

  isNeedsReview(item: any) {
    return item?.docType == 'NEEDS_REVIEW_POSTED' || item?.docType == 'NEEDS_REVIEW';
  }

  isSuggestedMatch(item: any) {
    return item?.docType == 'SUGGESTED_MATCH';
  }

  get suggestedMatches() {
    return (this.feljegyzesek || []).filter((item: any) => this.isSuggestedMatch(item));
  }

  get kontirLista() {
    return (this.feljegyzesek || []).filter((item: any) => {
      const inDocType = item?.docType == 'NEEDS_REVIEW_POSTED' || item?.docType == 'NEEDS_REVIEW' || item?.docType == 'REVIEWED';
      const validMatch = item?.matchStatus && !item.matchStatus.includes('posted_rule');
      return inDocType && validMatch;
    });
  }

  acceptSuggestedMatch(item: any) {
    if (!item) return;
    const wasKiegyenlites = item.docType === 'KIEGYENLITES';
    item.docType = 'KIEGYENLITES';
    this.applySuggestedMatchAccounts(item);
    this.applyInvoicePartnerToSuggestedMatch(item);
    if (!wasKiegyenlites) item._edited = true;
  }

  rejectSuggestedMatch(item: any) {
    if (!item) return;
    item.docType = 'NEEDS_REVIEW_POSTED';
    item._edited = true;
  }

  onItemEdited(item: any) {
    if (!item) return;
    item._edited = true;
    if (this.isNeedsReview(item)) {
      item.docType = 'REVIEWED';
    }
  }

  getHeaderColor(item: any) {
    if (item?._edited) return 'primary';
    if (this.isNeedsReview(item)) return 'danger';
    if (item?.docType == 'KIEGYENLITES') return 'success';
    return 'primary';
  }

  private accountStartsWith(value: any, prefix: string) {
    return String(value ?? '').startsWith(prefix);
  }

  private isBankAccount(value: any) {
    return this.accountStartsWith(value, '384');
  }

  private normalizeBankAccountNumber(value: any) {
    return String(value ?? '').replace(/[^A-Za-z0-9]/g, '').toUpperCase();
  }

  private getBankCounterpartyAccount(item: any) {
    const keys = [
      'bankAccountNumber',
      'bank_account_number',
      'counterpartyAccount',
      'counterparty_account',
      'partnerAccount',
      'partner_account',
      'partnerBankszamla',
      'partner_bankszamla',
      'partnerSzamlaszam',
      'partner_szamlaszam',
      'ellenoldaliBankszamla',
      'ellenoldali_bankszamla',
      'ellenoldaliSzamlaszam',
      'ellenoldali_szamlaszam',
      'ellenszamla',
      'ellenSzamla',
      'kedvezmenyezettSzamlaszam',
      'kedvezményezett számlaszáma',
      'kedvezményezett bankszámlaszáma',
      'megbizoSzamlaszam',
      'megbízó számlaszáma',
      'megbízó bankszámlaszáma',
      'bankszamla',
      'bankszámla',
      'bankszamlaszam',
      'bankszámlaszám',
      'szamlaszam',
      'számlaszám',
      'accountNumber',
      'account_number',
      'account',
    ];

    return this.getFirstString(item, keys);
  }

  private getHardcodedBankRule(item: any) {
    const accountNumber = this.normalizeBankAccountNumber(item?.bankAccountNumber || this.getBankCounterpartyAccount(item));
    if (!accountNumber) return null;

    return this.hardcodedBankRules.find(rule =>
      rule.accountNumbers.some(value => this.normalizeBankAccountNumber(value) === accountNumber)
    ) || null;
  }

  private applyHardcodedBankRule(item: any) {
    const rule = this.getHardcodedBankRule(item);
    if (!rule) return;

    item.hardcodedRuleKey = rule.key;
    item.hardcodedRuleName = rule.name;
    item.tipus = item.tipus == 'x' ? rule.tipus : item.tipus;
    item.tartozik = item.tartozik || rule.tartozik;
    item.kovetel = item.kovetel || this.adatok?.fokszam || '';
    item.bankRulePartnerNev = rule.partnerName;
    item.bankRulePartnerCode = rule.partnerCode;
    item.konyvelesiPartnerNev = item.konyvelesiPartnerNev || rule.partnerName;
    item.partnerNev = item.partnerNev || item.konyvelesiPartnerNev;
    item.partnerAzonosito = item.partnerAzonosito || rule.partnerCode;
    item.partnerCode = item.partnerCode || item.partnerAzonosito;
    item.partnerFixed = true;
  }

  private detectTipusFromAccounts(item: any) {
    if (this.accountStartsWith(item?.tartozik, '389') || this.accountStartsWith(item?.kovetel, '389')) return 'x';
    if (this.accountStartsWith(item?.tartozik, '532') || this.accountStartsWith(item?.kovetel, '532')) return 'a';
    if (this.accountStartsWith(item?.tartozik, '311') || this.accountStartsWith(item?.kovetel, '311')) return 'c';
    if (this.accountStartsWith(item?.tartozik, '4541') || this.accountStartsWith(item?.kovetel, '4541')) return 'b';
    if (this.isBankAccount(item?.tartozik)) return 'c';
    if (this.isBankAccount(item?.kovetel)) return 'b';
    return item?.tipus || 'x';
  }

  getKontirLabel(item: any) {
    const tipus = item?.tipus || this.detectTipusFromAccounts(item);
    if (tipus == 'b') return 'Szállító';
    if (tipus == 'c') return 'Vevő';
    if (tipus == 'x') return 'Függő';
    if (tipus == 'a') return 'Bank';
    return 'Vevő';
  }

  private getEloirasForItem(item: any) {
    if (item?.tipus == 'b') {
      return (this.feljegyzesek || []).filter(f => f.docType == "ELOIRAS" && this.accountStartsWith(f.tartozik, "4541"));
    }

    if (item?.tipus == 'c') {
      return (this.feljegyzesek || []).filter(f => f.docType == "ELOIRAS" && this.accountStartsWith(f.tartozik, "311"));
    }

    return [];
  }

  private refreshEloirasOptions(item: any) {
    if (!item) return;
    item.eloirasOptions = this.getEloirasForItem(item);
  }

  private applyTipusToItem(item: any, tipus: string) {
    if (!item) return;

    item.tipus = tipus;

    if (tipus == "a") {
      item.tartozik = "532";
      item.kovetel = this.adatok.fokszam;
      this.refreshEloirasOptions(item);
      return;
    }

    if (tipus == "b") {
      item.tartozik = "4541";
      item.kovetel = this.adatok.fokszam;
      this.refreshEloirasOptions(item);
      return;
    }

    if (tipus == "c") {
      item.tartozik = this.adatok.fokszam;
      item.kovetel = "311";
      this.refreshEloirasOptions(item);
      return;
    }

    this.refreshEloirasOptions(item);
  }

  private applySuggestedMatchAccounts(item: any) {
    if (!item) return;

    const amount = this.getSuggestedMatchSignedAmount(item);
    const bankAccount = this.adatok?.fokszam || item?.tartozik || item?.kovetel || '';

    if (amount >= 0) {
      item.tipus = 'c';
      item.tartozik = bankAccount;
      item.kovetel = '311';
      this.refreshEloirasOptions(item);
      return;
    }

    item.tipus = 'b';
    item.tartozik = '4541';
    item.kovetel = bankAccount;
    this.refreshEloirasOptions(item);
  }

  private normalizeLookupKey(value: any) {
    return String(value ?? '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '');
  }

  private getLooseValue(source: any, keys: string[]) {
    if (!source) return undefined;

    for (const key of keys) {
      if (source[key] !== undefined && source[key] !== null && String(source[key]).trim() !== '') {
        return source[key];
      }
    }

    const keyMap = new Map(Object.keys(source).map(key => [this.normalizeLookupKey(key), key]));
    for (const key of keys) {
      const sourceKey = keyMap.get(this.normalizeLookupKey(key));
      if (sourceKey && source[sourceKey] !== undefined && source[sourceKey] !== null && String(source[sourceKey]).trim() !== '') {
        return source[sourceKey];
      }
    }

    return undefined;
  }

  private parseSignedAmount(value: any) {
    if (value === undefined || value === null || value === '') return null;
    if (typeof value === 'number') return Number.isFinite(value) ? value : null;

    let normalized = String(value).trim().replace(/\s/g, '');
    if (!normalized) return null;
    if (normalized.includes(',') && !normalized.includes('.')) normalized = normalized.replace(',', '.');

    const dots = (normalized.match(/\./g) || []).length;
    if (dots > 1) {
      const lastDot = normalized.lastIndexOf('.');
      normalized = normalized.slice(0, lastDot).replace(/\./g, '') + normalized.slice(lastDot);
    }

    const parsed = Number(normalized);
    return Number.isFinite(parsed) ? parsed : null;
  }

  private getSuggestedMatchSignedAmount(item: any) {
    const direction = String(
      item?.__direction ??
      item?.direction ??
      item?.rawBankRow?.__direction ??
      item?.rawBankRow?.direction ??
      ''
    ).toUpperCase();

    if (direction === 'OUT') return -Math.abs(Number(item?.amount ?? 0));
    if (direction === 'IN') return Math.abs(Number(item?.amount ?? 0));

    const rawAmount = this.getLooseValue(item?.rawBankRow, [
      'összeg',
      'osszeg',
      'amount',
      'brutossz',
      'bankAmount',
      'bank_amount',
    ]);

    const parsedRawAmount = this.parseSignedAmount(rawAmount);
    if (parsedRawAmount !== null) return parsedRawAmount;

    return this.parseSignedAmount(item?.signedAmount) ?? Number(item?.amount ?? 0);
  }

  getEditableText(item: any) {
    const text = item?.text ?? '';
    if (!text.includes('|')) return text;

    const [left = '', right = ''] = text.split('|');
    return item?.matchStatus?.includes('posted_rule') ? left : right;
  }

  setEditableText(item: any, value: string) {
    if (!item) return;

    const currentText = item.text ?? '';
    const normalizedValue = value ?? '';

    if (!currentText.includes('|')) {
      item.text = normalizedValue;
      this.onItemEdited(item);
      return;
    }

    const [left = '', right = ''] = currentText.split('|');

    item.text = item?.matchStatus?.includes('posted_rule')
      ? `${normalizedValue}|${right}`
      : `${left}|${normalizedValue}`;

    this.onItemEdited(item);
  }

  getEditablePartner(item: any) {
    return item?.bankPartner || item?.partner || this.ugyfel?.NEV || '';
  }

  setEditablePartner(item: any, value: string) {
    if (!item) return;

    item.bankPartner = value ?? '';
    item.partner = value ?? '';
    this.onItemEdited(item);
  }

  private slugifyInstitutionName(value: any) {
    return String(value ?? '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/\b(kft|zrt|bt|kkt|nyrt|korlatolt felelossegu tarsasag|korl\.?\s*felel\.?\s*tars\.?)\b/g, '')
      .replace(/[^a-z0-9]+/g, '')
      .trim();
  }

  private extractPeriodYear() {
    const dates = (this.feljegyzesek || [])
      .map((item: any) => String(
        item?.date ??
        item?.bookingDate ??
        item?.valueDate ??
        ''
      ).trim())
      .filter(Boolean);

    for (const rawDate of dates) {
      const match = rawDate.match(/(20\d{2})/);
      if (match?.[1]) {
        return match[1];
      }
    }

    return '';
  }

  private buildPartnerInstitutionKey() {
    const rawAzonosito = String(
      this.ugyfel?.AZONOSITO ??
      this.ugyfel?.azonosito ??
      this.ugyfel?.KONYVELESIAZONOSITO ??
      this.ugyfel?.konyvelesiAzonosito ??
      this.cegParam ??
      ''
    ).trim();

    const periodYear = this.extractPeriodYear();
    if (!rawAzonosito || !periodYear) {
      return rawAzonosito;
    }

    if (new RegExp(`${periodYear}$`).test(rawAzonosito)) {
      return rawAzonosito;
    }

    return `${rawAzonosito}${periodYear}`;
  }

  private normalizePartnerEntry(entry: any) {
    const partnerAzonosito = String(
      entry?.PARTAZON ??
      entry?.partnerAzonosito ??
      entry?.partner_azonosito ??
      entry?.partnerCode ??
      entry?.partner_kod ??
      entry?.azonosito ??
      entry?.AZONOSITO ??
      entry?.id ??
      ''
    ).trim();

    const partnerNev = String(
      entry?.PARTNEV ??
      entry?.partnerNev ??
      entry?.partner_nev ??
      entry?.nev ??
      entry?.NEV ??
      ''
    ).trim();

    if (!partnerAzonosito && !partnerNev) return null;

    return {
      ...entry,
      partnerAzonosito,
      partnerNev,
      partnerDisplay: [partnerAzonosito, partnerNev].filter(Boolean).join(' - ') || 'Billiárd függő',
    };
  }

  private normalizePartnerResponse(response: any) {
    const source = Array.isArray(response)
      ? response
      : Array.isArray(response?.data)
        ? response.data
        : Array.isArray(response?.items)
          ? response.items
          : [];

    const normalized = source
      .map(entry => this.normalizePartnerEntry(entry))
      .filter(Boolean);

    const fallback = {
      partnerAzonosito: '',
      partnerNev: 'Billiárd függő',
      partnerDisplay: 'Billiárd függő',
    };

    return [fallback, ...normalized];
  }

  private syncSelectedPartner(item: any) {
    if (!item) return;

    const selected = item.selectedPartner;
    if (selected) {
      item.konyvelesiPartnerNev = selected.partnerNev || 'Billiárd függő';
      item.partnerNev = selected.partnerNev || 'Billiárd függő';
      item.partnerAzonosito = selected.partnerAzonosito || '';
      item.partnerCode = item.partnerAzonosito;
      item.partnerFixed = true;
      return;
    }

    item.bankPartner = item.bankPartner || item.partner || '';
    item.konyvelesiPartnerNev = item.konyvelesiPartnerNev || item.partnerNev || '';
    item.partnerNev = item.konyvelesiPartnerNev;
    item.partnerAzonosito = item.partnerAzonosito || '';
    item.partnerCode = item.partnerCode || item.partnerAzonosito || '';
  }

  private getFirstString(source: any, keys: string[]) {
    for (const key of keys) {
      const value = source?.[key];
      if (value !== undefined && value !== null && String(value).trim() !== '') {
        return String(value).trim();
      }
    }

    return '';
  }

  private extractInvoicePartner(source: any, allowGenericPartner = true) {
    const partnerNevKeys = [
      'szamlaPartnerNev',
      'szamla_partner_nev',
      'szamlaPartner',
      'invoicePartnerNev',
      'invoicePartnerName',
      'invoice_partner_nev',
      'invoice_partner_name',
      'matchedPartnerNev',
      'matchedPartnerName',
      'matched_partner_nev',
      'matched_partner_name',
      'eloirasPartnerNev',
      'eloirasPartnerName',
      'eloiras_partner_nev',
      'eloiras_partner_name',
      'PARTNEV',
      'partnev',
    ];

    if (allowGenericPartner) {
      partnerNevKeys.push(
        'partnerNev',
        'partner_nev',
        'partnerName',
        'partner'
      );
    }

    return {
      partnerNev: this.getFirstString(source, partnerNevKeys),
      partnerAzonosito: this.getFirstString(source, [
        'szamlaPartnerAzonosito',
        'szamlaPartnerKod',
        'szamla_partner_azonosito',
        'szamla_partner_kod',
        'invoicePartnerAzonosito',
        'invoicePartnerCode',
        'invoice_partner_azonosito',
        'invoice_partner_code',
        'matchedPartnerAzonosito',
        'matchedPartnerCode',
        'matched_partner_azonosito',
        'matched_partner_code',
        'eloirasPartnerAzonosito',
        'eloirasPartnerCode',
        'eloiras_partner_azonosito',
        'eloiras_partner_code',
        'PARTAZON',
        'partazon',
        'PARTKOD',
        'partkod',
        'acpartkod',
        'pcode',
        'partnerAzonosito',
        'partner_azonosito',
        'partnerCode',
        'partner_code',
        'partner_kod',
      ]),
    };
  }

  private isInvoiceSideRow(item: any) {
    return item?.docType == 'ELOIRAS' || String(item?.matchStatus ?? '').includes('invoice');
  }

  private getLinkedInvoiceRows(item: any) {
    const suggestedInvoiceNos = [
      ...(Array.isArray(item?.suggestedSingles) ? item.suggestedSingles : []),
      ...(Array.isArray(item?.suggestedPairs)
        ? item.suggestedPairs.flatMap((pair: any) => Array.isArray(pair?.invoices) ? pair.invoices : [])
        : []),
    ].map((suggestion: any) => suggestion?.invoiceNo);

    const linkedDocNos = new Set(
      [
        ...(Array.isArray(item?.kontir) ? item.kontir : []),
        ...suggestedInvoiceNos,
        item?.linkKey,
        item?.linkedDocNo,
        item?.matchedDocNo,
        item?.matchDocNo,
        item?.invoiceDocNo,
        item?.szamlaDocNo,
        item?.eloirasDocNo,
      ]
        .flatMap(value => String(value ?? '').split(/[|,;\s]+/))
        .map(value => value.trim())
        .filter(Boolean)
    );

    if (!linkedDocNos.size) return [];

    return (this.feljegyzesek || []).filter((row: any) =>
      row?.docType == 'ELOIRAS' && linkedDocNos.has(String(row?.docNo ?? '').trim())
    );
  }

  private getSuggestedInvoicePartners(item: any) {
    const suggestionRows = [
      ...(Array.isArray(item?.suggestedSingles) ? item.suggestedSingles : []),
      ...(Array.isArray(item?.suggestedPairs)
        ? item.suggestedPairs.flatMap((pair: any) => Array.isArray(pair?.invoices) ? pair.invoices : [])
        : []),
    ];

    return suggestionRows
      .map((row: any) => this.extractInvoicePartner(row, false))
      .filter(partner => partner.partnerNev || partner.partnerAzonosito);
  }

  private normalizePartnerCode(value: any) {
    return String(value ?? '').trim().toLowerCase();
  }

  private findPartnerNameByCode(partnerAzonosito: any) {
    const code = this.normalizePartnerCode(partnerAzonosito);
    if (!code) return '';

    const partner = (this.partnerOptions || []).find((option: any) =>
      this.normalizePartnerCode(option?.partnerAzonosito) === code
    );

    return String(partner?.partnerNev ?? '').trim();
  }

  private withPartnerNameFromCode(partner: any) {
    const partnerAzonosito = String(partner?.partnerAzonosito ?? '').trim();
    const partnerNev = String(partner?.partnerNev ?? '').trim() || this.findPartnerNameByCode(partnerAzonosito);

    return {
      partnerNev,
      partnerAzonosito,
    };
  }

  private findEloirasPartnerByCode(partnerAzonosito: any) {
    const code = this.normalizePartnerCode(partnerAzonosito);
    if (!code) return { partnerNev: '', partnerAzonosito: '' };

    const row = (this.feljegyzesek || []).find((item: any) => {
      if (item?.docType != 'ELOIRAS') return false;
      const partner = this.extractInvoicePartner(item, true);
      return this.normalizePartnerCode(partner.partnerAzonosito) === code;
    });

    return this.withPartnerNameFromCode(this.extractInvoicePartner(row, true));
  }

  getSuggestedMatchPartnerLabel(item: any) {
    const linkedPartners = this.getLinkedInvoiceRows(item)
      .map(row => this.extractInvoicePartner(row, true))
      .filter(partner => partner.partnerNev || partner.partnerAzonosito)
      .map(partner => [partner.partnerAzonosito, partner.partnerNev].filter(Boolean).join(' - '));

    if (linkedPartners.length) {
      return [...new Set(linkedPartners)].join(', ');
    }

    const suggestedPartners = this.getSuggestedInvoicePartners(item)
      .map(partner => this.withPartnerNameFromCode(partner))
      .map(partner => [partner.partnerAzonosito, partner.partnerNev].filter(Boolean).join(' - '));

    if (suggestedPartners.length) {
      return [...new Set(suggestedPartners)].join(', ');
    }

    const explicitPartner = this.extractInvoicePartner(item, false);
    if (explicitPartner.partnerNev || explicitPartner.partnerAzonosito) {
      return [explicitPartner.partnerAzonosito, explicitPartner.partnerNev].filter(Boolean).join(' - ');
    }

    return this.ugyfel?.NEV || '';
  }

  private applyInvoicePartnerToSuggestedMatch(item: any) {
    const directPartner = this.extractInvoicePartner(item, false);
    const linkedInvoice = this.getLinkedInvoiceRows(item)
      .map(row => this.extractInvoicePartner(row, this.isInvoiceSideRow(row)))
      .map(partner => this.withPartnerNameFromCode(partner))
      .find(partner => partner.partnerNev || partner.partnerAzonosito);
    const suggestedPartner = this.getSuggestedInvoicePartners(item)
      .map(partner => this.withPartnerNameFromCode(partner))
      .find(partner => partner.partnerNev || partner.partnerAzonosito);

    const partnerNev = linkedInvoice?.partnerNev || suggestedPartner?.partnerNev || directPartner.partnerNev;
    const partnerAzonosito = linkedInvoice?.partnerAzonosito || suggestedPartner?.partnerAzonosito || directPartner.partnerAzonosito;

    if (!partnerNev && !partnerAzonosito) return;

    item.konyvelesiPartnerNev = partnerNev || item.konyvelesiPartnerNev || item.partnerNev || '';
    item.partnerNev = partnerNev || item.partnerNev || '';
    item.partner_nev = item.partnerNev;
    item.partnerAzonosito = partnerAzonosito || item.partnerAzonosito || '';
    item.partner_azonosito = item.partnerAzonosito;
    item.partnerCode = item.partnerAzonosito;
    item.partnerFixed = true;
    item.selectedPartner = null;
    this.tryAutoSelectPartner(item);
  }

  private tryAutoSelectPartner(item: any) {
    if (!item || !this.partnerOptions?.length) return;

    const currentPartner = String(item.partnerNev || item.partner || '').trim().toLowerCase();
    const currentAzon = String(item.partnerAzonosito || '').trim().toLowerCase();

    const match = this.partnerOptions.find((partner: any) => {
      const partnerName = String(partner?.partnerNev || '').trim().toLowerCase();
      const partnerId = String(partner?.partnerAzonosito || '').trim().toLowerCase();
      return (currentAzon && partnerId === currentAzon) || (currentPartner && partnerName === currentPartner);
    });

    if (match) {
      item.selectedPartner = match;
      this.syncSelectedPartner(item);
    }
  }

  async loadPartnerOptions(forceReload = false, item: any = null) {
    const intezmeny = this.buildPartnerInstitutionKey();
    const currentKey = intezmeny;

    if (this.partnerOptionsLoading) return;
    if (!forceReload && this.partnerOptionsLoadedFor === currentKey && this.partnerOptions.length) {
      this.tryAutoSelectPartner(item);
      return;
    }

    this.partnerOptionsLoading = true;

    try {
      if (!intezmeny) {
        this.partnerOptions = this.normalizePartnerResponse([]);
        this.partnerOptionsLoadedFor = currentKey;
        this.tryAutoSelectPartner(item);
        return;
      }

      console.log('loadpartner intezmeny=', intezmeny);
      const response = await firstValueFrom(
        this.http
          .get(environment.n8n + '/webhook/loadpartner?intezmeny=' + encodeURIComponent(intezmeny))
          .pipe(
            timeout(15000),
            catchError(() => of(null))
          )
      );

      const normalized = this.normalizePartnerResponse(response);
      this.partnerOptions = normalized;
      this.partnerOptionsLoadedFor = currentKey;
      this.tryAutoSelectPartner(item);

    } finally {
      this.partnerOptionsLoading = false;
    }
  }

  onPartnerSelected(item: any, partner: any) {
    if (!item) return;

    item.selectedPartner = partner || null;
    if (!partner) {
      item.konyvelesiPartnerNev = '';
      item.partnerNev = '';
      item.partnerAzonosito = '';
      item.partnerCode = '';
      item.partnerFixed = false;
    }
    this.syncSelectedPartner(item);
    this.onItemEdited(item);
  }

  private isSuggestedKontirItem(item: any) {
    return item?.docType == 'SUGGESTED_MATCH'
      || String(item?.matchStatus ?? '').includes('suggest')
      || Array.isArray(item?.suggestedSingles)
      || Array.isArray(item?.suggestedPairs);
  }

  private shouldUseInvoicePartnerForSubmission(item: any) {
    return this.isSuggestedKontirItem(item)
      || item?.docType == 'KIEGYENLITES'
      || String(item?.matchStatus ?? '').includes('invoice');
  }

  private getSuggestedSubmissionPartner(item: any) {
    const linkedInvoice = this.getLinkedInvoiceRows(item)
      .map(row => this.extractInvoicePartner(row, this.isInvoiceSideRow(row)))
      .map(partner => this.withPartnerNameFromCode(partner))
      .find(partner => partner.partnerNev || partner.partnerAzonosito);
    const suggestedPartner = this.getSuggestedInvoicePartners(item)
      .map(partner => this.withPartnerNameFromCode(partner))
      .find(partner => partner.partnerNev || partner.partnerAzonosito);
    const directPartner = this.extractInvoicePartner(item, false);
    const codeMatchedEloiras = this.findEloirasPartnerByCode(
      linkedInvoice?.partnerAzonosito ||
      suggestedPartner?.partnerAzonosito ||
      directPartner.partnerAzonosito ||
      item?.partnerAzonosito ||
      item?.partnerCode
    );

    return {
      partnerNev: linkedInvoice?.partnerNev || suggestedPartner?.partnerNev || codeMatchedEloiras.partnerNev || directPartner.partnerNev || '',
      partnerAzonosito: linkedInvoice?.partnerAzonosito || suggestedPartner?.partnerAzonosito || codeMatchedEloiras.partnerAzonosito || directPartner.partnerAzonosito || '',
    };
  }

  private buildSubmissionItem(item: any) {
    const selectedPartner = this.normalizePartnerEntry(item?.selectedPartner) || item?.selectedPartner;
    const useInvoicePartner = this.shouldUseInvoicePartnerForSubmission(item);
    const suggestedPartner = useInvoicePartner
      ? this.getSuggestedSubmissionPartner(item)
      : { partnerNev: '', partnerAzonosito: '' };
    const {
      eloirasOptions,
      selectedPartner: _selectedPartner,
      _original,
      _edited,
      ...submissionItem
    } = item || {};

    const bankPartner = String(item?.bankPartner ?? item?.partner ?? '').trim();

    const partnerAzonosito = String(
      selectedPartner?.partnerAzonosito ||
      suggestedPartner.partnerAzonosito ||
      item?.partnerAzonosito ||
      item?.partnerCode ||
      item?.partner_kod ||
      ''
    ).trim();

    const fallbackPartnerNev = String(item?.konyvelesiPartnerNev || item?.partnerNev || '').trim();
    const safeFallbackPartnerNev = useInvoicePartner && fallbackPartnerNev.toLowerCase() === bankPartner.toLowerCase()
      ? ''
      : fallbackPartnerNev;

    const rawPartnerNev = String(
      selectedPartner?.partnerNev ||
      suggestedPartner.partnerNev ||
      safeFallbackPartnerNev ||
      ''
    ).trim();

    const normalizedPartnerNev = rawPartnerNev || '';
    const accountingPartnerName = normalizedPartnerNev || (!useInvoicePartner ? fallbackPartnerNev : '');
    const hasChosenAccountingPartner = Boolean(selectedPartner || partnerAzonosito || accountingPartnerName);
    const payloadPartner = hasChosenAccountingPartner && accountingPartnerName
      ? accountingPartnerName
      : bankPartner;

    return {
      ...submissionItem,
      partner: payloadPartner,
      bankPartner,
      bank_partner: bankPartner,
      bankAccountNumber: item?.bankAccountNumber || '',
      bank_account_number: item?.bankAccountNumber || '',
      konyvelesiPartnerNev: accountingPartnerName,
      partnerName: accountingPartnerName,
      partnerNev: accountingPartnerName,
      partner_nev: accountingPartnerName,
      partnerAzonosito,
      partner_azonosito: partnerAzonosito,
      partnerCode: partnerAzonosito,
      partner_code: partnerAzonosito,
      PARTAZON: partnerAzonosito,
      PARTNEV: accountingPartnerName,
      acpartkod: partnerAzonosito,
      partnerFixed: Boolean(selectedPartner || item?.partnerFixed || partnerAzonosito),
    };
  }

  restoreItem(item: any) {
    if (!item?._original) return;
    item.docType = item._original.docType;
    item.tipus = item._original.tipus;
    item.szabaly = item._original.szabaly;
    item.szabalyfeltetel = [...item._original.szabalyfeltetel];
    item.tartozik = item._original.tartozik;
    item.kovetel = item._original.kovetel;
    item.kontir = [...(item._original.kontir || [])];
    item.reszosszeg = item._original.reszosszeg || 0;
    item.partner = item._original.partner || '';
    item.bankPartner = item._original.bankPartner || item.partner || '';
    item.konyvelesiPartnerNev = item._original.konyvelesiPartnerNev || '';
    item.partnerNev = item._original.partnerNev || '';
    item.partnerAzonosito = item._original.partnerAzonosito || '';
    item.partnerCode = item._original.partnerCode || item.partnerAzonosito || '';
    item.selectedPartner = null;
    this.refreshEloirasOptions(item);
    this.tryAutoSelectPartner(item);
    item._edited = false;
  }

  toggleSzabaly(item: any) {
    if (!item) return;
    item.szabaly = item.szabaly == 'a' ? 'b' : 'a';
    if (item.szabaly == 'b') {
      this.loadPartnerOptions(true, item);
    }
    this.onItemEdited(item);
  }

  tipusChange(e, id) {
    const selectedTipus = e?.target?.value;
    this.feljegyzesek.forEach(f => {
      if (f.docNo == id) {
        this.applyTipusToItem(f, selectedTipus);
        this.onItemEdited(f);
      }
    })
  }
  changedSelect(item){
    console.log(item)
    this.feljegyzesek.forEach(f => {
        if (f.docNo == item.docNo) {
          
          const docNoSet = new Set(item.kontir);
          f.reszosszeg = this.feljegyzesek
  .filter(item => docNoSet.has(item.docNo))
  .reduce((acc, item) => acc + Number(item.amount || 0), 0);
          this.onItemEdited(f)
        }
      })
  }


  async kuldes() {
    await this.data.showLoading("Feladás...")
    const payload = this.feljegyzesek.map(item => this.buildSubmissionItem(item));
    this.http
      .post(
        environment.n8n + '/webhook/feladas',
        { adoszam: this.ugyfel.ADOSZAM, data: payload, iban: this.adatok.iban }
      )
      .subscribe({
        next: async (response2: any) => {

          await this.data.hideLoading()
          this.data.sendToast("Sikeres feladás!", "success")
        },
        error: async () => {
          await this.data.hideLoading()
        },

      });
  }



  close() {
    this.feljegyzesmodal.dismiss()
  }
  async openFeljegyzes(f) {
    await this.data.showLoading("Váltás a könyvelt cégre...")
    try {
      await this.data.setStorage("kivceg", f)
      window.location.replace("/b/bank")
    } finally { this.data.hideLoading() }
    /*console.log(f)
    this.f = f
    this.feljegyzesmodal.present()*/
  }

}
